import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 354512 359256"
    {...props}
  >
    <defs>
      <style>
        {
          ".str0{stroke:#000;stroke-width:3959.75}.fil0,.fil1{fill:#1c1b17}.fil0{fill-rule:nonzero}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541135856">
        <path
          d="m337795 242283 6355 3752 3295 1943-1939 3305c-8376 14254-18769 27074-30810 38111l5 16c-12019 11027-25733 20292-40740 27464v15c-4589 2183-9344 4178-14228 5955-3222 1185-6470 2261-9728 3233l14145 20282 6459 9255-10752-3399-75786-23935-8953-2827 8387-4261 70865-35955 10040-5103-4849 10180-9515 19965c1663-556 3331-1138 4994-1756 4173-1538 8335-3295 12430-5243h5c13657-6527 26123-14956 37062-24980 10918-10019 20360-21654 27999-34645l1954-3321 3305 1949zM80032 71385l-5665 79273-800 11234-6225-9384-12113-18266c-3388 15101-4449 30503-3181 45708 1497 17902 6215 35550 14151 52142h10c1257 2651 2546 5155 3825 7499 1330 2432 2738 4843 4198 7202l2037 3274-3294 2006-6324 3871-3243 1985-2011-3253c-1606-2587-3149-5243-4609-7919-1539-2811-2942-5545-4189-8174-8823-18479-14046-38117-15631-58030-1455-18198 135-36661 4770-54667l-24839 1663-11230 753 8434-7452 59563-52609 7036-6205-670 9349zM312758 43079l10076-22984 4531-10326 2708 10944 19097 77132 2255 9099-7992-4921-67653-41691-9562-5893 11183-1180 21461-2260c-9478-7852-19902-14540-30976-19898-13599-6563-28181-11136-43230-13402l-3793-571 561-3783 1096-7296 572-3799 3778 561c16779 2500 33070 7634 48234 15049 13610 6652 26320 15148 37654 25219z"
          className="fill stroke1"
          style={{
            strokeWidth: 3959.75,
            fillRule: "nonzero",
          }}
        />
        <path
          d="M222905 134304c16702-62150-18765-101810-66453-97248-22501 2152-44987 30889-31179 57131 12981 24543 40143 22293 48452 50198 7743-10538 23223-22485 49180-10081zM162048 173226c-62145 16603-78872 67202-51035 106207 13044 18390 49263 23535 65035-1580 14737-23514-743-45922 19331-67124-13069-1382-31184-8766-33331-37503zM226173 206458c45449 45542 97622 34718 117509-8865 9318-20547-4302-54424-33980-55546-27713-1034-39301 23629-67658 16816 5321 12019 7930 31351-15871 47595zM228517 171361c0 13713-11115 24735-24850 24735-13620 0-24725-11022-24725-24735 0-13709 11105-24731 24725-24731 13735 0 24850 11022 24850 24731z"
          className="fill stroke1"
          style={{
            strokeWidth: 3959.75,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
